import type { IApp } from "@/types";
import { deFlatten } from "@/utils";
import _ from "lodash";
import { computed } from "vue";
import { useRoute } from "vue-router";
import * as uuid from "uuid";

const useRouteQuery = () => {
  const route = useRoute();
  const params = deFlatten(route.query);
  const customerIds = computed(() => {
    console.log("params", params);
    const ids = params["customer-id"];
    if (_.isArray(ids)) {
      for (const id of ids) {
        if (!_.isString(id) || !uuid.validate(id)) {
          return [];
        }
      }
      return ids;
    }
    return [];
  });

  const preview = route.query.preview == "true" ? true : false;
  const dateRange: IApp.MonthRange | undefined = params["date-range"];
  const comparedRange: IApp.MonthRange | undefined = params["compared-range"];
  const mode: IApp.PrintMode | undefined = params["mode"];
  const requestId: string | undefined = params["request-id"];
  const reportId: string | undefined = params["report-id"];
  const showSummary: boolean | undefined = params["show-summary"]
    ? params["show-summary"] === "true"
    : undefined;
  const lazy: boolean = params["lazy"] === "true";

  return {
    customerIds,
    preview,
    requestId,
    reportId,
    dateRange,
    comparedRange,
    mode,
    showSummary,
    lazy
  };
};

export default useRouteQuery;
